<template>
    <v-row justify="center" class="my-0 py-0">
      <v-col cols="12" xs="12" sm="8" md="6" class="pa-0 ma-0">
        <v-card flat>
                <qrcode-stream @decode="onDecode" @init="onInit"></qrcode-stream>
                <!-- surface camera errors so users are not left with a blank scanner -->
                <v-alert v-if="cameraError" type="error" dense class="ma-0 mt-2">
                    {{ cameraError }}
                </v-alert>
        </v-card>
      </v-col>
    </v-row>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'
export default {
    components: {
        QrcodeStream,
    },
    computed: {
        cameraError() {
            return this.$store.getters['qr_code_reader_store/GET_getError']
        },
    },
    created() {
        this.$store.dispatch('qr_code_reader_store/ACT_error', '') // clear any error from a previous scan
    },
    methods: {
        onDecode(result) {
          this.MIX_decodeResult(result);
        },
        async onInit(promise) {
          try {
            await promise;
            this.$store.dispatch('qr_code_reader_store/ACT_error', '') // camera started cleanly
          } catch (error) {
            this.MIX_onInitError(error);
          }
        },
    }
}
</script>
